// extracted by mini-css-extract-plugin
export default {"headerBar":"NewMyEmployee_headerBar__Rc4tI"};